import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { CreateCameraTrapDTO } from "./type";
import type { CameraTrap } from "@typings/entities/devices/cameraTrap";

export async function createCameraTrap(
  cameraTrap: CreateCameraTrapDTO,
): Promise<CameraTrap> {
  const response = await apiClient.post<CameraTrap>(
    apiPaths.devices.cameraTraps.create,
    cameraTrap,
  );
  return response.data;
}
